module.exports = __webpack_public_path__ + "img/application-epoxy.0ef896c7.jpg";